.promocodeWrapper {
  position: relative;
  margin-top: 24px;
  margin-bottom: 16px;
  width: 100%;
  min-height: 144px;
  background-color: #fff0d8;
  border-radius: 24px;
  padding: 16px;
}

.promocodeRound {
  width: 24px;
  height: 24px;
  min-width: 24px;
  min-height: 24px;
  border-radius: 24px;
  background-color: #fffbf1;
  position: absolute;
  bottom: 68px;
  z-index: 1;
}

.promocodeRoundLeft {
  left: -12px;
}

.promocodeRoundRight {
  right: -12px;
}

.promocodeTag {
  height: 33px;
  min-width: 82px;
  min-height: 33px;
  background: var(--ed-brand, #ba61fe);
  box-shadow: 1px -3px 12px 0px rgba(255, 255, 255, 0.6) inset;
  background-size: contain;
  background-position: center center;
  background-repeat: no-repeat;
  position: absolute;
  top: 16px;
  right: -8px;
  padding: 4px 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 20px 20px 5px 20px;

  @at-root html[lang='pt'] & {
    top: 8px;
  }

  @at-root html[lang='es'] & {
    top: 8px;
  }
}

.promocodeTag:after {
  content: '';
  display: block;
  width: 6px;
  height: 5px;
  background: url(./img/vector.png) no-repeat;
  background-position: center;
  background-size: contain;
  position: absolute;
  bottom: -5px;
  right: 2px;
}

.promocodeTagK9 {
  background: #e44a08;
}

.promocodeTagK9:after {
  background: url(./img/vectorK9.png) no-repeat;
  background-position: center;
  background-size: contain;
}

.promocodeTagV2 {
  padding: 0px 0px 10px 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: -6px;
  right: 6px;
  width: 121px;
  height: 59px;
  background: url(./img/tagV2.png) no-repeat;
  background-size: contain;
  background-position: center;

  .promocodeTagText {
    color: #FFFBF2;
    font-family: var(--ed-font-rounded, ui-rounded, 'SF Pro Rounded', Nunito, 'SF Pro Text', -apple-system, BlinkMacSystemFont, 'Roboto',
      sans-serif);
    font-size: 22.439px;
    font-weight: 800;
    line-height: 28.049px;
    letter-spacing: 0.09px;

    @at-root html[lang='pt'] & {
      font-size: 28.049px;
    }

    @at-root html[lang='es'] & {
      font-size: 28.049px;
    }
  }
}

.promocodeTagPaywall2paymentBlocks {
  position: absolute;
  top: 16px;
  right: -8px;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 82px;
  min-height: 28px;
  padding: 4px 10px;
  border-radius: 20px 20px 5px 20px;
  background: #e44a08;
  box-shadow: inset 1px -3px 12px 0 rgba(255, 255, 255, 0.6);

  .promocodeTagText {
    letter-spacing: 0.064px;
  }

  &::after {
    content: '';
    position: absolute;
    right: 2px;
    bottom: -5px;
    width: 6px;
    height: 5px;
    background: #c33900;
    clip-path: polygon(100% 0, 0 0, 0 100%);
  }
}

.promocodeTagText {
  font-family: var(--ed-font-rounded, ui-rounded, 'SF Pro Rounded', Nunito, 'SF Pro Text', -apple-system, BlinkMacSystemFont, 'Roboto',
    sans-serif);
  font-size: 16px;
  font-style: normal;
  font-weight: 800;
  line-height: 20px;
  letter-spacing: -0.4px;
  color: #fffbf1;

  @at-root html[lang='pt'] & {
    font-size: 14px;
  }

  @at-root html[lang='es'] & {
    font-size: 14px;
  }
}

.promocodeDashedLine {
  width: 100%;
  height: 1px;
  background-image: url(./img/line.svg);
  background-position: center center;
  background-repeat: repeat;
  position: absolute;
  bottom: 79px;
  left: 0;
}

.promocodeRows {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.promocodeRowFirst {
  width: 100%;
  display: flex;
  padding-bottom: 20px;
  padding-right: 70px;

  @at-root html[lang='es'] & {
    padding-right: 110px;
  }

  @at-root html[lang='ru'] & {
    padding-right: 85px;
  }

  @media (max-width: 400px) {
    @at-root html[lang='it'] & {
      padding-right: 105px;
    }

    @at-root html[lang='ru'] & {
      padding-right: 105px;
    }

    @at-root html[lang='fr'] & {
      padding-right: 105px;
    }

    @at-root html[lang='uk'] & {
      padding-right: 105px;
    }

    @at-root html[lang='es'] & {
      padding-right: 115px;
    }
  }
}

.promocodeLabel {
  margin-right: 6px;
  width: 28px;
  height: 29px;
  min-width: 28px;
  min-height: 29px;
  background-image: url(./img/label.svg);
  background-size: contain;
  background-position: center center;
  background-repeat: no-repeat;
  position: relative;
  top: -1px;
}

.promocodeTitle {
  font-family: var(--ed-font-rounded, ui-rounded, 'SF Pro Rounded', Nunito, 'SF Pro Text', -apple-system, BlinkMacSystemFont, 'Roboto',
    sans-serif);
  font-size: 19px;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: -0.3px;
  padding-top: 2px;
}

.promocodeRowSecond {
  margin-top: 19px;
  width: 100%;
  height: 44px;
  max-height: 44px;
  min-height: 44px;
  display: flex;
}

.promocodeCodeBlock {
  margin-right: 8px;
  width: 100%;
  height: 44px;
  min-height: 44px;
  border-radius: 12px;
  border: 0.5px solid var(--ed-border, #ffe4ba);
  background-color: #fffbf1;
  display: flex;
  align-items: center;
  padding: 0 12px;
  //   white-space: nowrap;
  overflow: hidden;
  //   text-overflow: ellipsis;
}

.promocodeTimerBlock {
  width: 100px;
  min-width: 100px;
  height: 44px;
  min-height: 44px;
  border-radius: 12px;
  background-color: #ffe4ba;
  display: flex;
  align-items: center;
  justify-content: center;
}

.promocodeCheck {
  margin-right: 6px;
  width: 16px;
  height: 16px;
  min-width: 16px;
  min-height: 16px;
  background-image: url(./img/check.svg);
  background-size: contain;
  background-position: center center;
  background-repeat: no-repeat;
}

.promocodeText {
  font-size: 15px;
  font-weight: 400;
  line-height: 20px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.timerCell {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.timerCellNumber {
  width: 37px;
  color: #ff8e00;
  font-size: 28px;
  font-weight: 700;
  line-height: 34px;
  letter-spacing: -0.4px;
  font-family: var(--ed-font-rounded, ui-rounded, 'SF Pro Rounded', Nunito, 'SF Pro Text', -apple-system, BlinkMacSystemFont, 'Roboto',
    sans-serif);
  display: flex;
}

.timerCellNumberMinutes {
  justify-content: flex-end;
}

.timerCellNumberSeconds {
  justify-content: flex-start;
}

.timerCellDivider {
  color: #ff8e00;
  font-size: 28px;
  font-weight: 700;
  line-height: 34px;
  margin: 0 2px;
  opacity: 0.5;
  font-family: var(--ed-font-rounded, ui-rounded, 'SF Pro Rounded', Nunito, 'SF Pro Text', -apple-system, BlinkMacSystemFont, 'Roboto',
    sans-serif);
}

.secondScreenWrapperStyle {
  .promocodeRound {
    background-color: #00a36f !important;
  }
}

// Dark mode
:global body.dark {
  :local {
    .promocodeWrapper {
      background-color: #402f19;
    }

    .promocodeTitle {
      color: #fffbf2;
    }

    .promocodeRound {
      background-color: #181716;
    }

    .promocodeDashedLine {
      background-image: url(./img/lineDark.svg);
      background-position: center center;
      background-repeat: repeat;
    }

    .promocodeLabel {
      background-image: url(./img/labelDark.png);
      background-size: contain;
      background-position: center center;
      background-repeat: no-repeat;
    }

    .promocodeTimerBlock {
      background-color: #734302;
    }

    .timerCellNumber,
    .timerCellDivider {
      color: #fffbf2;
    }

    .promocodeCodeBlock {
      background-color: #181716;
      border-color: var(--ed-border, #555048);
      color: #ece7dd;
    }
  }
}

:global body.dark #secondScreenWrapper {
  :local {
    .secondScreenWrapperStyle {
      .promocodeRound {
        background-color: #2a2928 !important;
      }
    }
  }
}
